import axios from "axios";

export default function exportStockOutSummary(params) {
  try {
    const response = axios.post(
      "/distributor/system-admin/summary/v1/data-summary/stockout-reporting-summary",
      params,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    console.error("Failed to fetch stock out summary:", error);
    throw error.response?.data || error;
  }
}
